export default __webpack_public_path__ + "static/media/proj-03-title.bafe1433.png";